var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllieCongrats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 140
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-part": "star",
    fill: "#eef755",
    d: "M98.246 130.573l-9.146 4.954a3.255 3.255 0 01-4.691-3.512l1.746-10.49a3.391 3.391 0 00-.929-2.948l-7.4-7.431a3.358 3.358 0 011.793-5.681l10.224-1.531a3.237 3.237 0 002.434-1.822l4.574-9.545a3.193 3.193 0 015.8 0l4.572 9.545a3.242 3.242 0 002.434 1.822l10.225 1.531a3.358 3.358 0 011.791 5.681l-7.4 7.431a3.392 3.392 0 00-.931 2.948l1.746 10.49a3.254 3.254 0 01-4.69 3.512l-9.146-4.953a3.146 3.146 0 00-3.006-.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7181",
    d: "M101.446 69.107a2.818 2.818 0 01-4.807-1.951l-.077-5.027a2.817 2.817 0 115.632-.083l.077 5.026a2.809 2.809 0 01-.825 2.035z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b75ff",
    d: "M173.063 62.441a2.816 2.816 0 01-1.598-4.935l3.8-3.29a2.817 2.817 0 013.686 4.26l-3.8 3.29a2.808 2.808 0 01-2.088.675zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M46.217 64.594a2.817 2.817 0 01-4.779 2.02l-3.609-3.5a2.817 2.817 0 013.925-4.042l3.609 3.5a2.809 2.809 0 01.854 2.022zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7181",
    d: "M49.186 110.07L11.91 87.86c-3.23-1.93-.34-6.76 2.89-4.84l37.28 22.26c2.96 1.83.65 6.68-2.89 4.84z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M63.922 117.895a2.818 2.818 0 01-3.187-4.1l.022-.039a2.818 2.818 0 014.913 2.76l-.021.038a2.813 2.813 0 01-1.727 1.341zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b75ff",
    d: "M72.122 122.795a2.817 2.817 0 01-3.189-4.094l.02-.04a2.818 2.818 0 014.924 2.746l-.022.038a2.81 2.81 0 01-1.733 1.35zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M148.153 109.293a2.817 2.817 0 01-.713-5.14l37.28-22.26a2.818 2.818 0 112.889 4.838l-37.281 22.257a2.81 2.81 0 01-2.175.305zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7181",
    d: "M135.59 116.822a2.8 2.8 0 01-1.72-1.335l-.022-.038a2.818 2.818 0 114.904-2.775l.022.038a2.818 2.818 0 01-3.183 4.109zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M127.39 121.718a2.81 2.81 0 01-1.731-1.35l-.022-.038a2.818 2.818 0 014.923-2.745l.022.038a2.818 2.818 0 01-3.192 4.095zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ef29c",
    d: "M129.424 68.418a2.817 2.817 0 01-2.067-4.408l24.891-35.944a2.817 2.817 0 014.631 3.208l-24.89 35.943a2.817 2.817 0 01-2.565 1.201zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M121.047 80.553a2.805 2.805 0 01-1.404-.524l-.034-.025a2.817 2.817 0 013.302-4.565l.035.025a2.816 2.816 0 01-1.899 5.088zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ef29c",
    d: "M115.572 88.459a2.8 2.8 0 01-1.411-.525l-.035-.025a2.816 2.816 0 113.317-4.553l.035.025a2.817 2.817 0 01-1.907 5.082zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b75ff",
    d: "M70.098 68.445a2.815 2.815 0 01-2.565-1.203l-24.89-35.943a2.817 2.817 0 014.632-3.207l24.89 35.942a2.816 2.816 0 01-2.066 4.411zm0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7181",
    d: "M78.475 80.58a2.816 2.816 0 01-1.904-5.085l.037-.025a2.816 2.816 0 013.308 4.558l-.035.025a2.806 2.806 0 01-1.406.527zm0 0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb146",
    d: "M83.95 88.484a2.817 2.817 0 01-1.913-5.078l.035-.025a2.817 2.817 0 113.328 4.545l-.035.025a2.8 2.8 0 01-1.415.533zm0 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#eef755",
    d: "M128.306 34.735a7.564 7.564 0 10-7.56 7.789 7.677 7.677 0 007.56-7.789zm0 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ef29c",
    d: "M100.168 42.251a3.711 3.711 0 10-7.418 0 3.711 3.711 0 107.418 0zm0 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7181",
    d: "M155.01 82.699a6.067 6.067 0 10-6.064 6.246 6.158 6.158 0 006.064-6.246zm0 0M74.94 35.17a2.818 2.818 0 01-5.14.716l-2.58-4.316a2.817 2.817 0 114.84-2.888l2.58 4.316a2.812 2.812 0 01.3 2.172zm0 0"
  })));
}
export default SvgIllieCongrats;